import { type ReactNode, type FC } from 'react'

interface Props {
  description: string
  icon: ReactNode
  testId: string
  title: string
}

/**
 * Used for iterated Welcome steps
 * @param description - Description of the step
 * @param icon - Icon
 * @param testId - Test ID for the component
 * @param title - Title of the step
 * @returns React.FC
 */
export const WelcomeStepV2: FC<Props> = ({ description, icon, testId, title }) => {
  return (
    <div className="flex flex-row items-start mb-md" data-testid={testId}>
      {/* Number */}
      <div className="min-w-10 min-h-10 flex justify-center items-center mr-sm">{icon}</div>
      {/* Content */}
      <div>
        {/* Title */}
        <div className="typo-primary-md-semibold text-text-header" data-testid={`${testId}-title`}>
          {title}
        </div>
        {/* Description */}
        <div className="typo-primary-base-light text-text-meta" data-testid={`${testId}-description`}>
          {description}
        </div>
      </div>
    </div>
  )
}
